// 雷达图配置
export const createRadarOption = (
  myData: { name: string; value: number }[],
  industryData: { name: string; value: number }[],
  averageData: { name: string; value: number }[],
) => ({
  radar: {
    indicator: [
      { name: '覆盖率' },
      { name: '首选提及' },
      { name: '首选推荐' },
      { name: '信息完整度' },
      { name: '提及强度' },
      { name: '引用链接数' },
    ],
    splitLine: {
      lineStyle: {
        color: '#D7E8FF', // 新增网格线颜色设置
      },
    },
    name: {
      textStyle: {
        color: '#4E5969',
      },
    },
    axisLine: {
      lineStyle: { color: '#D7E8FF' },
    },
    center: ['50%', '45%'], // 调整雷达图中心位置，垂直方向上移
    radius: '65%', // 调整雷达图半径，留出空间
  },
  legend: {
    show: true,
    data: ['行业头部（加权系数）', '行业Top3均值（加权系数）', '我的（加权系数）'],
    bottom: '3%',
    left: 'center',
    itemWidth: 15,
    itemHeight: 15,
    formatter(name) {
      // 为不同的 name 设置别名
      const aliasMap = {
        '行业头部（加权系数）': '行业头部',
        '行业Top3均值（加权系数）': '行业Top3均值',
        '我的（加权系数）': '我的',
      }
      return aliasMap[name] || name
    },
  },
  color: ['#F99057', '#0FC6C2', '#165DFF'],
  tooltip: {
    trigger: 'item', // 改回item触发模式
    formatter(params) {
      const indicator = [
        { name: '覆盖率' },
        { name: '首选提及' },
        { name: '首选推荐' },
        { name: '信息完整度' },
        { name: '提及强度' },
        { name: '引用链接数' },
      ]
      let ret = `
      <div style="margin: 0px 0 0;line-height:1;">
        <div style="font-size:14px;color:#666;font-weight:400;line-height:1;">
          ${params.seriesName}
        </div>
        <div style="margin: 10px 0 0;line-height:1;">
      `
      params.data.value.forEach((item, index) => {
        ret += `
        <div style="margin: 8px 0 0;line-height:1;">
          ${params.marker}
          <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${
            indicator[index].name
          }</span>
          <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${
            item == 0 ? 0 : item.toFixed(2)
          }</span>
          <div style="clear:both">
        </div>
        `
      })
      ret += `
        <div style="clear:both"></div>
      </div>
      <div style="clear:both"></div>
      </div>
      `
      return ret
    },
  },
  series: [
    {
      type: 'radar',
      name: '行业头部（加权系数）',
      data: [
        {
          value: industryData.map(item => Math.min(item.value / 100, 1)),
          areaStyle: { color: 'rgba(249, 144, 87, 0.3)' },
          lineStyle: { color: '#F99057', width: 1.5 },
          itemStyle: { color: '#F99057' },
          symbolSize: 6,
        },
      ],
    },
    {
      type: 'radar',
      name: '行业Top3均值（加权系数）',
      data: [
        {
          value: averageData.map(item => Math.min(item.value / 100, 1)),
          areaStyle: { color: 'rgba(15, 198, 194, 0.3)' }, // 新增紫色系
          lineStyle: { color: '#0FC6C2', width: 1.5 }, //
          itemStyle: { color: '#0FC6C2' }, // 紫色主色
          symbolSize: 6,
        },
      ],
    },
    {
      type: 'radar',
      name: '我的（加权系数）',
      data: [
        {
          value: myData.map(item => Math.min(item.value / 100, 1)),
          areaStyle: { color: 'rgba(64, 128, 255, 0.3)' },
          lineStyle: { color: '#165DFF', width: 1.5 },
          itemStyle: { color: '#165DFF' },
          symbolSize: 6,
        },
      ],
    },
  ],
})
// 词云配置函数
export const createWordCloudOption = (
  data: { name: string; value: number }[],
  colors: string[],
) => ({
  series: [
    {
      type: 'wordCloud',
      shape: 'circle',
      sizeRange: [12, 40],
      rotationRange: [0, 0],
      gridSize: 8,
      textStyle: {
        color: () => colors[Math.floor(Math.random() * colors.length)],
      },
      emphasis: {
        textStyle: {
          color: '#FF4703',
        },
      },
      data,
    },
  ],
})
// 饼图配置
export { chartConfig as createPieConfig } from '@views/main/pages/view-effect/config.js'
